import { useAppStore } from "@hooks/useAppStore";
import type { ExamBrandingSchemaType } from "@memorang/constants/config/schema";
import { useExamContext } from "../contexts/ExamContext";

export const useExamBranding = (): ExamBrandingSchemaType | undefined => {
	const {
		currentExamContext: { examId },
	} = useExamContext();
	const brandingMap = useAppStore((store) => store.exam.branding);
	const brandingProfiles = useAppStore((store) => store.exam.brandingProfiles);

	const profileName = examId ? brandingMap?.[examId] : undefined;
	return profileName ? brandingProfiles?.[profileName] : undefined;
};
